/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_controls__partner_hotel = /** @type {(inputs: {}) => string} */ () => {
	return `Hotels`
};

const en_map_controls__partner_hotel = /** @type {(inputs: {}) => string} */ () => {
	return `Hotels`
};

const es_map_controls__partner_hotel = /** @type {(inputs: {}) => string} */ () => {
	return `Hoteles`
};

const fr_map_controls__partner_hotel = /** @type {(inputs: {}) => string} */ () => {
	return `Hôtels`
};

const it_map_controls__partner_hotel = /** @type {(inputs: {}) => string} */ () => {
	return `Alberghi`
};

const nl_map_controls__partner_hotel = /** @type {(inputs: {}) => string} */ () => {
	return `Hotels`
};

const pt_map_controls__partner_hotel = /** @type {(inputs: {}) => string} */ () => {
	return `Hotéis`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_controls__partner_hotel(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_controls__partner_hotel", locale)
	if (locale === "de") return de_map_controls__partner_hotel(inputs)
	if (locale === "en") return en_map_controls__partner_hotel(inputs)
	if (locale === "es") return es_map_controls__partner_hotel(inputs)
	if (locale === "fr") return fr_map_controls__partner_hotel(inputs)
	if (locale === "it") return it_map_controls__partner_hotel(inputs)
	if (locale === "nl") return nl_map_controls__partner_hotel(inputs)
	return pt_map_controls__partner_hotel(inputs)
};